import type { Config, CreateConfigParameters } from '@wagmi/core'
import { evmChains } from 'sushi/evm'
import { http, type Chain } from 'viem'

function pluck<
  Arr extends readonly Record<string, any>[],
  K extends keyof Arr[number],
>(arr: Arr, key: K): { [I in keyof Arr]: Arr[I][K] } {
  // @ts-ignore
  return arr.map((item) => item[key]) as any
}

export const publicChains = pluck(evmChains, 'viemChain') satisfies Readonly<
  Chain[]
>

export const publicWagmiConfig = {
  chains: publicChains,
  transports: Object.fromEntries(
    publicChains.map((chain) => [chain.id, http()]),
  ) as any,
  batch: {
    multicall: {
      wait: 64,
    },
  },
} as const satisfies CreateConfigParameters

type _PublicWagmiConfig = Config<
  (typeof publicWagmiConfig)['chains'],
  (typeof publicWagmiConfig)['transports']
>

// Speedup
export type PublicWagmiConfig = Omit<_PublicWagmiConfig, 'chains'> & {
  chains: [_PublicWagmiConfig['chains'][number]]
}
